import { render, staticRenderFns } from "./Pl5.vue?vue&type=template&id=07b8356c&scoped=true"
import script from "./Pl5.vue?vue&type=script&lang=js"
export * from "./Pl5.vue?vue&type=script&lang=js"
import style0 from "./Pl5.vue?vue&type=style&index=0&id=07b8356c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b8356c",
  null
  
)

export default component.exports